import React from 'react';
import './ContemplatingIndicator.css';

const CONTEMPLATING_WORDS = [
  'Contemplating',
  'Reflecting',
  'Pondering',
  'Processing',
  'Considering',
  'Thinking',
  'Weighing',
  'Sitting with that',
  'Taking that in',
  'Mulling it over',
  'Gathering thoughts',
  'Pausing',
];

function ContemplatingIndicator() {
  const [word] = React.useState(
    () => CONTEMPLATING_WORDS[Math.floor(Math.random() * CONTEMPLATING_WORDS.length)],
  );
  return (
    <span className="contemplating" aria-label={word}>
      {word.split('').map((char, index) => (
        <span
          key={index}
          className="contemplating__char"
          style={{ animationDelay: `${index * 0.1}s` }}
          aria-hidden="true"
        >
          {char === ' ' ? ' ' : char}
        </span>
      ))}
    </span>
  );
}

export default ContemplatingIndicator;
